import React, { useEffect } from 'react';
import { HeaderFlexWrap, TitleFlexWrap } from '../styled';
import MetricSelector from './MetricSelector';
import TrendSelector from './TrendSelector';
import UnitToggle from '../../common/UnitToggle';
import Resize from './Resize';
import FilterBuilder from '../drawer/FilterBuilder';
import { heightAtom, modeAtom, TABLE_MODES, unitAtom } from '../atoms';
import CompareBuilder from '../drawer/CompareBuilder';
import { viewContextSelector } from '@store/trends/base/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { ViewContexts } from '@store/trends/base/reducer';
import { setViewContext } from '@store/trends/base/actions';
import { realTimeModeOnTrendsSelector } from '@store/common/selectors';
import ExportTable from '../ExportTable';
import { Space } from 'antd';
import { useAtom } from 'jotai';
import { tid } from '@utils/test';
import MetricTags from './MetricTags';
import DimensionsSelectorPopup from '../dimensionSelectorPopup';
import { checkFeature } from '@utils/platform/features/checkFeature';
import { tableCompareEnabledSelector } from '@store/trends/birdChart/selectors';

const DimensionHeader = () => {
  const viewContext = useSelector(viewContextSelector);
  const isLiveMode = useSelector(realTimeModeOnTrendsSelector);

  const [unit, setUnit] = useAtom(unitAtom);
  const [height, setHeight] = useAtom(heightAtom);
  const [mode, setMode] = useAtom(modeAtom);

  const isTableCompareEnabled = useSelector(tableCompareEnabledSelector);

  const dispatch = useDispatch();

  const handleUnitChange = (value) => {
    setUnit(value);
  };

  const handleHeightChange = (value) => {
    setHeight(value);
  };

  const handleFilterBuilderToggle = (value) => {
    const newMode = value ? TABLE_MODES.filter : TABLE_MODES.drilldown;
    setMode(newMode);
  };

  const handleCompareBuilderToggle = (value) => {
    const newMode = value ? TABLE_MODES.compare : TABLE_MODES.drilldown;
    setMode(newMode);
  };

  useEffect(() => {
    if (isTableCompareEnabled) {
      handleUnitChange('%');
    }
  }, [isTableCompareEnabled]);

  useEffect(() => {
    if (viewContext === ViewContexts.RT_TRENDS) {
      handleFilterBuilderToggle(true);
    } else if (viewContext === ViewContexts.RT_FILTERS) {
      handleCompareBuilderToggle(true);
    }

    return () => {
      // clear
      dispatch(setViewContext(''));
    };
  }, [viewContext]);

  // disable interactions when a drawer is active
  const hasActiveDrawer = mode !== TABLE_MODES.drilldown;

  return (
    <HeaderFlexWrap {...tid('controls')}>
      <TitleFlexWrap>
        <TrendSelector />
        <MetricTags />
      </TitleFlexWrap>
      <Space style={{ justifyContent: 'right' }}>
        <Resize value={height} onChange={handleHeightChange} />
        <FilterBuilder
          onToggle={handleFilterBuilderToggle}
          visible={mode === TABLE_MODES.filter}
          disabled={hasActiveDrawer}
        />
        <ExportTable />
        <CompareBuilder
          onToggle={handleCompareBuilderToggle}
          visible={mode === TABLE_MODES.compare}
          disabled={hasActiveDrawer || isLiveMode || !checkFeature('trends.base.compare', true)}
        />
        <DimensionsSelectorPopup />
        <MetricSelector />
        <UnitToggle selectedUnit={unit} onChange={handleUnitChange} />
      </Space>
    </HeaderFlexWrap>
  );
};

export default DimensionHeader;
